export function groupBy(arr: any, key: any) {
  return arr.reduce((acc: any, obj: any) => {
    const group = obj[key]
    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push(obj)
    return acc
  }, {})
}

export function omitEmptyDeep<T>(input: T): T {
  // 1) Arrays
  if (Array.isArray(input)) {
    const cleaned = input
      .map(omitEmptyDeep)
      .filter(
        (v) =>
          v !== undefined &&
          v !== "" &&
          v !== null &&                        // 👈 descarta null
          !(Array.isArray(v) && v.length === 0) &&
          !(isPlainObject(v) && Object.keys(v).length === 0)
      );
    // @ts-expect-error (preserva el tipo externo)
    return cleaned;
  }

  // 2) Objetos “planos”
  if (isPlainObject(input)) {
    const acc: Record<string, unknown> = {};
    Object.entries(input).forEach(([k, v]) => {
      if (v === "" || v === undefined || v === null) return; // 👈 descarta null
      const cleaned = omitEmptyDeep(v as any);
      const shouldKeep =
        !(Array.isArray(cleaned) && cleaned.length === 0) &&
        !(isPlainObject(cleaned) && Object.keys(cleaned).length === 0);
      if (shouldKeep) acc[k] = cleaned;
    });
    // @ts-expect-error
    return acc;
  }

  // 3) Primitivo
  return input;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return (
    typeof value === "object" &&
    value !== null &&
    Object.getPrototypeOf(value) === Object.prototype
  );
}
